module.exports = __webpack_public_path__ + "img/icon_mensageria.aa6f792d.png";